/*
 * VULCAN
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/authenticatedUserMappers";
import * as Parameters from "../models/parameters";
/** Class representing a AuthenticatedUser. */
var AuthenticatedUser = /** @class */ (function () {
    /**
     * Create a AuthenticatedUser.
     * @param {SecurityContext} client Reference to the service client.
     */
    function AuthenticatedUser(client) {
        this.client = client;
    }
    AuthenticatedUser.prototype.getPermissions = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getPermissionsOperationSpec, callback);
    };
    AuthenticatedUser.prototype.getBranches = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getBranchesOperationSpec, callback);
    };
    AuthenticatedUser.prototype.getUserProfile = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getUserProfileOperationSpec, callback);
    };
    AuthenticatedUser.prototype.getRoles = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getRolesOperationSpec, callback);
    };
    return AuthenticatedUser;
}());
export { AuthenticatedUser };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/me/rolePermissions",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getBranchesOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/me/userBranches",
    queryParameters: [
        Parameters.applicationName1
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "UserBranchInfo"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getUserProfileOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/me/userProfile",
    responses: {
        200: {
            bodyMapper: Mappers.UserProfileResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getRolesOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/me/userRoles",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RoleResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=authenticatedUser.js.map